import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import JsonBlock from "../leads/conversation/JsonBlock";
import type { WebhookCatalogEntry, WebhookEventState, WebhookEventType } from "./types";

type WebhookEventListProps = {
  catalog: WebhookCatalogEntry[];
  events: WebhookEventState[];
  selected: WebhookEventType[];
  disabled: boolean;
  onToggle: (type: WebhookEventType, checked: boolean) => void;
};

const WebhookEventList = ({
  catalog,
  events,
  selected,
  disabled,
  onToggle,
}: WebhookEventListProps): JSX.Element => (
  <Accordion type="multiple" className="divide-y divide-gray-200 border-y border-gray-200">
    {catalog.map((entry) => {
      const checkboxId = `webhook-event-${entry.type}`;
      const hasOverride = events.find((event) => event.type === entry.type)?.hasOverride ?? false;

      return (
        <AccordionItem key={entry.type} value={entry.type} className="border-b-0 py-3">
          <div className="flex items-start gap-3">
            <Checkbox
              id={checkboxId}
              className="mt-0.5"
              checked={selected.includes(entry.type)}
              disabled={disabled}
              onCheckedChange={(checked) => onToggle(entry.type, checked === true)}
            />
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <Label htmlFor={checkboxId} className="text-sm font-semibold leading-snug">
                  {entry.label}
                </Label>
                <code className="break-all text-xs text-gray-600">{entry.type}</code>
                {hasOverride && <Badge variant="outline">Configuración personalizada</Badge>}
              </div>
              <p className="text-sm text-gray-600">{entry.description}</p>
              {hasOverride && (
                <p className="text-xs text-gray-600">
                  Palomma le configuró a este evento una URL o un secreto propio, así que los
                  cambios de URL o de secreto de esta página no lo afectan.
                </p>
              )}
              <AccordionTrigger className="min-h-11 flex-none justify-start gap-1 py-0 text-sm font-medium text-gray-700 md:min-h-8">
                Ver ejemplo
              </AccordionTrigger>
              <AccordionContent className="pb-1">
                <JsonBlock label="Ejemplo" value={entry.example} className="max-h-96" />
              </AccordionContent>
            </div>
          </div>
        </AccordionItem>
      );
    })}
  </Accordion>
);

export default WebhookEventList;
